<template>
  <dataTable :name="'HotelMatchList'" :columnDefs="columnDefs" ref="agGrid" :data="data" @unMatch="unMatch($event)"></dataTable>
</template>

<script>
  export default {
    name: 'MatchList',
    props:{
        setModel:Object
    },
    data(){
      return { 
        data:null,
        columnDefs:[
          {"headerName":"OperatorName","field":"OperatorName",rowGroup:false,"enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {"headerName":"OperatorHotelName","field":"OperatorHotelName",rowGroup:false,"enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {"headerName":"Star","field":"Star",rowGroup:false,"enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","cellClick":true,"width":80},
          {"headerName":"Region","field":"Region","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {"headerName":"OperatorRoomCount","field":"OperatorRoomCount","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {
              headerName: "",
              type:"action",
              width:40,
              buttons:[
                {
                  classes:"btn btn-xs waves-effect waves-light btn-danger",
                  text:'<i class="fas fa-times"></i>',
                  emit:"unMatch"
                }
              ],
              filter:false,
              sortable:false,
              resizable: false,
              floatingFilter: false,
              cellRenderer: this.$BtnCellRenderer,
              cellRendererParams: {
                clicked: function(field) {
                  this.$emit(field.emit,field.data)
                }
              }
        }
        ]
        
      }
    },
    created(){
      this.$appAxiosAdmin.get(`Hotels/MatchList/`+this.setModel.Id).then(response => {
          this.data=response.data;
      });
    },
    methods:{
      unMatch(item){
          this.$swal({
              icon:"question",
              title:"Warning",
              text:"Do you want to cancel the mapping of  "+item.OperatorHotelName+"?",
              showCancelButton:true,
              confirmButtonText:"Yes",
              cancelButtonText:"No"
          }).then(question=>{
            if(question.isConfirmed){
              this.$appAxiosAdmin.get(`TOURSCOPE/OperatorHotels/Unmatch/`+item.Id).then(() => {
                  this.$refs.agGrid.changeRow('Id',{...item,HotelId:null,Name3:null});
                  this.$swal({
                      icon:"success",
                      title:"Success",
                      text:"The hotel match has been cancelled.",
                      timer: 2000,
                      confirmButtonText:"Okey"
                  });
                  this.$refs.agGrid.removeRow([item]);
              }).catch(err=>{
                this.$isError(err);
              });
            }
          });
      }
    }
  }
</script>
